import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, InputGroup, FormControl, Form} from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import UserService from '../../service/userService'
import 'react-toastify/dist/ReactToastify.css';
import './Login.css';
import logo from './rtaf_logo.png';
import background from './background.jpg';

const errorNotify = (msg) => {
  toast.error(msg, {
    theme: 'dark'
  })
}

async function loginUser(credentials) {
  const userService = new UserService()
  return await userService.login(credentials)
}
 

export default function Login({ setToken, isUserType }) {
  const [password, setPassword] = useState();
  const [username, setUserName] = useState();
  const [passwordPlaceholder, setPasswordPlaceholder] = useState('รหัสผ่าน');
  const [usernamePlaceholder, setUsernamePlaceholder] = useState('ชื่อผู้ใช้');

  useEffect(() => {
    if (!isUserType) {
      setUsernamePlaceholder('เลขประจำตัวข้าราชการ(12345567890)');
      setPasswordPlaceholder('วันเดือนปีเกิด ค.ศ.(02121994)');
    }
  }, []);

  const handleSubmit = async e => {
    e.preventDefault();
    const user_name =  isUserType ? `${username}@rtaf.mi.th` : username;
    const res = await loginUser({
      user_name,
      password,
      is_user_type: isUserType
    });
    if (res.token) {
      setToken(res);
    } else {
      errorNotify(res.message)
    }
  }

  return(
    <div className="login-wrapper" style={{ backgroundImage: `url(${background})` }}>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div className='login-container'>
        <img src={logo} className="rtaf-logo" />
        <h1>เข้าสู่ระบบ</h1> 
        <Form onSubmit={handleSubmit}>
          {isUserType && <InputGroup className="mb-3">
            <FormControl
              required
              placeholder={usernamePlaceholder}
              aria-describedby="basic-addon2"
              onChange={e => setUserName(e.target.value)}
            />
            <InputGroup.Text id="basic-addon2">@rtaf.mi.th</InputGroup.Text>
          </InputGroup>}
          {!isUserType && <InputGroup className="mb-3">
            <FormControl
              required
              placeholder={usernamePlaceholder}
              aria-describedby="basic-addon2"
              className='username-input'
              onChange={e => setUserName(e.target.value)}
            />
          </InputGroup>}
          <InputGroup className="mb-3">  
            <Form.Control 
              required
              type="password" 
              placeholder={passwordPlaceholder} 
              onChange={e => setPassword(e.target.value)} 
            />
          </InputGroup>
          <div className="btn-submit-login">
            <Button variant="outline-primary" size="md" type="submit">ตกลง</Button>
          </div>
          <div className="create-info-container">
            {/* <div className='lable-text'>จัดทำโดย: </div> */}
            <div className='lable-info'>
              <span>กพ.ทอ.</span><br />
              <span>กองการศึกษา สปพ.กพ.ทอ.</span><br />
              <span>กองข้อมูลกำลังพล สปพ.กพ.ทอ</span><br />
              <span>ศซบ.ทอ.</span><br />
              <span>น.ท.บุรีรัตน์ เข็มทอง  ศซบ.ทอ.</span><br />
              <span>ร.ต.ทวีพร จิตรอักษร  ศซบ.ทอ.</span>
            </div>
          </div>
        </Form>
      </div>
    </div>
  )
}

Login.propTypes = {
  setToken: PropTypes.func.isRequired
}